import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * This component listens for variant update events and updates the price display accordingly.
 * It handles price updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog, quick-add-dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog, quick-add-dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const priceSource =
      event.detail.data.html.querySelector('.price-container-pdp[ref="priceContainer"]') ||
      event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!priceSource || !currentPrice) return;

    if (currentPrice.innerHTML !== priceSource.innerHTML) {
      currentPrice.replaceWith(priceSource.cloneNode(true));
    }

    this.#reapplyQuickAddPromo();
  };

  /**
   * Variant HTML is the plain PDP price. Put the modal's promo style back on it.
   */
  #reapplyQuickAddPromo() {
    const modal = this.closest('#quick-add-modal-content');
    if (!modal || !window.PWPdpPromo || typeof window.PWPdpPromo.applyWithin !== 'function') return;
    const raw = modal.getAttribute('data-pw-promo');
    if (!raw) return;

    let promo = null;
    try {
      promo = JSON.parse(raw);
    } catch {
      return;
    }

    window.PWPdpPromo.applyWithin(modal, promo);
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}
